import { get, downloadBlob, post } from './client';
import { makeGrowerPath } from './utils';

export function runCornRX(aaid, payload) {
  return post(makeGrowerPath(`/cornrx/run/${aaid}`), payload);
}

export function getGrowerHasCornRX(growerId) {
  return get(`/cornrx/has/${growerId}`);
}

export function getAAIDCornRX(aaid) {
  return get(makeGrowerPath(`/cornrx/data/${aaid}`));
}

export function getCoefficent(aaid, growerId) {
  return get(`/cornrx/coefficient/${growerId}/${aaid}`);
}

export function downloadCornRxFields(growerId, aaids, rate) {
  return downloadBlob(`/corn/${growerId}/shapefile/${rate}`, aaids);
}

export function downloadCornRxPdfs(growerId, aaids, rate) {
  return downloadBlob(`/corn/${growerId}/pdf/${rate}`, aaids);
}

export function setCornRXAdjustments(spacing, data) {
  return post(makeGrowerPath(`/cornrx/adjustments/${spacing}`), data);
}
